"use client";

import React, { useRef } from "react";
import { motion } from "framer-motion";
import Heading from "@/components/molecules/Heading";
import { convertLexicalWithInternalLinks } from "@/lib/lexical";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { InfoTextWithMapBlockData } from "@/page-builder/fragments/InfoTextWithMapBlock/types";
import { getAccessibleImageProps } from "@/lib/image-alt";

const ModuloTextoMap = ({
  title,
  description,
  image,
  captions
}: InfoTextWithMapBlockData) => {

  const {isMobile} = useMediaQuery();
  const sectionRef = useRef(null);
  
  const Content = () => (
    <section ref={sectionRef} className="container mx-auto">
      <div className={`grid grid-cols-1 md:grid-cols-8 xl:gap-32 md:gap-0 gap-16 md:items-center`}>
        
        <div className={`flex col-span-4 flex-col justify-center space-y-8`}>
          <Heading title={title} />

          <div
            className="text-m-regular text-neutral-900 prose prose-ul:my-0 marker:text-neutral-900 py-8"
            dangerouslySetInnerHTML={{
              __html: convertLexicalWithInternalLinks( description as any ) ,
            }}
          />
        </div>
        <div className={`relative flex flex-col col-span-4 justify-end`}>
          <motion.img
            src={image?.url || ""}
            {...getAccessibleImageProps(image?.alt)}
            width={592}
            height={592}
            className="w-full h-auto"
             initial={!isMobile ? { opacity: 100, x: 1 * 80 } : {}}
              animate={!isMobile ? { opacity: 1, x: 0 } : {}}
              transition={!isMobile ? { 
                x: { duration: 2, ease: "easeOut" },
                opacity: { duration: 1.5 }
              } : {}}
          />

          <div className="">
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-16 justify-between">
            {captions?.map((caption, index) => (
              <div key={index} className="flex justify-center gap-8 flex-row items-center">
                <span className={`${caption?.color === "green1" ? "bg-primary-600" : "bg-primary-200"} w-24 h-24 rounded-full text-m-bold text-neutral-900`} />
                <span className="text-m-regular text-neutral-900">{caption?.label}</span>
              </div>
            ))}
          </div>
          </div>
        </div>
      </div>
    </section>
  );
  
  return <Content />
  
};

export default ModuloTextoMap;